<template>
  <div class="cases" v-if="deviceType!=='pc'">
    <h1 class="title">真实案例</h1>
    <section class="wrap" v-if="list.length">
      <div class="contain">
        <div class="item" v-for="(item,index) in list" :key="index">
          <img class="img" :src="item.img" alt />
          <p class="item-title">{{item.title}}</p>
          <p class="text">{{item.desc}}</p>
          <!-- <a class="btn" href>查看详情</a> -->
        </div>
      </div>
    </section>
    <section class="video-box" v-if="videoList.length">
      <div id="video"></div>
      <div class="option">
        <p class="desc" id="video-text"></p>
        <div class="option-btn" v-if="videoList.length>=2">
          <span :class="[videoIndex===0?'disable':'','prev']" @click="changeVideo('prev',$event)"></span>
          <span
            :class="[videoIndex===(videoList.length-1)?'disable':'','next']"
            @click="changeVideo('next',$event)"
          ></span>
        </div>
      </div>
    </section>
  </div>
  <div v-else class="cases-pc">
    <h1 class="cases-title">真实案例</h1>
    <div class="gallery-top" v-if="list.length">
      <swiper :options="swiperOptionTop">
        <swiper-slide :key="index" v-for="(item ,index) in list">
          <img class="item" :src="item.img" alt="轮播" />
          <div class="right">
            <p class="item-title">{{item.title}}</p>
            <p class="text">{{item.desc}}</p>
            <!-- <a href class="btn">查看详情</a> -->
          </div>
        </swiper-slide>
      </swiper>
      <div class="set" v-if="list.length>2">
        <div class="top-prev prev" slot="button-prev"></div>
        <div class="top-next next" slot="button-next"></div>
      </div>
    </div>

    <div class="gallery-bottom" v-if="videoList.length">
      <div class="thumbs-wrap">
        <div class="thumbs" ref="thumbs">
          <div
            :class="[videoIndex===index?'active':'','thumbs-item']"
            v-for="(item,index) in videoList"
            :key="index"
            @click="getVideo(index)"
          >
            <div class="img">
              <img :src="item.img" alt />
            </div>
            <div class="video-desc">
              <span>{{item.title}}</span>
              <div class="date">
                {{item.smallimg}}
                <div class="playing">
                  <span class="playing__bar playing__bar1"></span>
                  <span class="playing__bar playing__bar2"></span>
                  <span class="playing__bar playing__bar3"></span>
                  <span class="playing__bar playing__bar4"></span>
                  <span class="playing__bar playing__bar5"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="set">
          <div :class="[videoIndex===0?'disable':'','prev']" @click="changeVideo('prev',$event)"></div>
          <div
            :class="[videoIndex===(videoList.length-1)?'disable':'','next']"
            @click="changeVideo('next',$event)"
          ></div>
        </div>
      </div>
      <div id="video"></div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import XHR from '../api'

export default {
  name: 'Cases',
  props: [],
  data: () => ({
    casesHid: 4117,
    videoHid: 4118,
    videoList: [],
    videoIndex: 0,
    prevStatus: false,
    nextStatus: true,
    list: [],
    swiperOptionTop: {
      slidesPerView: 2,
      navigation: {
        nextEl: '.top-next',
        prevEl: '.top-prev'
      },
      autoplayDisableOnInteraction: false,
      autoplayStopOnLastSlide: false
    }
  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
    console.log(this.deviceType)
  },
  mounted () {
    this.getHandWork(20, this.casesHid, 'list')
    this.getHandWork(19, this.videoHid, 'videoList')
  },
  methods: {
    // 前后切换视频
    changeVideo (type, e) {
      var target = e.target
      if (!target.classList.contains('disable')) {
        if (type === 'prev') {
          this.videoIndex--
        }
        if (type === 'next') {
          this.videoIndex++
        }
        this.video()
      }
    },
    // 播放选中视频
    getVideo (index) {
      this.videoIndex = index
      this.video()
    },
    // 手工位
    getHandWork (type, id, key) {
      XHR.getHandWork({
        type: type,
        hid: id
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this[key] = data
          if (key === 'videoList') {
            this.$nextTick(() => {
              this.video()
            })
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 播放视频
    video (index) {
      this.$nextTick(() => {
        if (this.deviceType === 'pc') {
          const active = this.$refs.thumbs.querySelector('.active')
          this.$refs.thumbs.scrollTop = active.offsetTop - 20
        }
        this.playVideo(this.videoList, this.videoIndex, 'video', '#video-text')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.cases {
  position: relative;
  width: 100%;
  .title {
    font-size: 24px;
    color: #000000;
    line-height: 30px;
    padding: 40px 0 28px 20px;
  }

  .wrap {
    display: flex;
    overflow-x: auto;
    // padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 16px;
    .contain {
      // width: 100%;
      display: flex;
      padding-right: 8px;
      padding-left: 20px;
      .item {
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border: 1px solid #e5e6e7;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 16px 16px 20px;
        margin-right: 12px;
        min-width: 284px;
        width: 284px;
        background: #ffffff;
        .img {
          width: 250px;
          height: 168px;
        }
        .item-title {
          font-size: 16px;
          color: #000000;
          line-height: 20px;
          margin-top: 12px;
          margin-bottom: 8px;
          font-weight: bold;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .text {
          position: relative;
          flex: 1;
          margin-bottom: 16px;
          font-size: 14px;
          color: #6d7278;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          line-clamp: 5;
          -webkit-box-orient: vertical;
        }
        .btn {
          display: inline-block;
          border: 1px solid #3d72f5;
          width: 104px;
          height: 32px;
          font-size: 14px;
          color: #3d72f5;
          line-height: 30px;
          text-align: center;
          box-sizing: border-box;
          &::after {
            margin-left: 4px;
            content: "\e7fb";
            display: inline-block;
            font-family: "iconfont";
          }
        }
      }
    }
  }

  .video-box {
    width: 100%;
    height: 281px;
    padding: 12px 12px 16px;
    box-sizing: border-box;
    background-image: linear-gradient(0deg, #3d83ff 0%, #3a48db 100%);
    #video {
      width: 351px;
      height: 197px;
    }
    .option {
      margin-top: 16px;
      display: flex;
      align-items: center;
      height: 40px;
      .desc {
        flex: 1;
        font-size: 16px;
        color: #ffffff;
        line-height: 20px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .option-btn {
        margin-left: 31px;
        span {
          position: relative;
          display: inline-block;
          box-sizing: border-box;
          width: 30px;
          height: 30px;
          background: #09dda8;
          text-align: center;
          line-height: 30px;
          color: #ffffff;
          font-size: 12px;

          &.prev::before {
            content: "\e7fa";
            display: inline-block;
            font-family: "iconfont";
          }
          &.next {
            margin-left: 4px;
            &::before {
              content: "\e7fb";
              display: inline-block;
              font-family: "iconfont";
            }
          }
        }
      }
    }
  }
}
.cases-pc {
  width: 1200px;
  margin: auto;
  .cases-title {
    font-size: 40px;
    color: #000000;
    text-align: center;
    line-height: 50px;
    padding: 60px 0 40px;
  }
  .gallery-top {
    border: 1px solid #e5e6e7;

    .swiper-container {
      height: 100%;
      .swiper-slide {
        display: flex;
        padding: 20px;
        box-sizing: border-box;
        img {
          height: 180px;
          width: 270px;
        }
        .right {
          display: flex;
          flex-direction: column;
          padding: 0 20px;
          .item-title {
            font-size: 18px;
            color: #000000;
            line-height: 24px;
            font-weight: bold;
            margin-bottom: 8px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .text {
            font-size: 14px;
            color: #6d7278;
            line-height: 22px;
            // flex: 1;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            line-clamp: 6;
            -webkit-box-orient: vertical;
          }
          .btn {
            display: inline-block;
            width: 104px;
            height: 32px;
            background: #ffffff;
            font-size: 14px;
            color: #3d72f5;
            border: 1px solid #3d72f5;
            line-height: 32px;
            text-align: center;
            &::after {
              margin-left: 4px;
              content: "\e7fb";
              display: inline-block;
              font-family: "iconfont";
            }
          }
        }
      }
    }
  }
  .gallery-bottom {
    display: flex;
    height: 450px;
    margin-top: 60px;
    margin-bottom: 80px;
    box-shadow: 0 8px 24px 0 rgba(61, 114, 245, 0.4);

    .thumbs-wrap {
      position: relative;
      height: 100%;
      width: 400px;
      display: flex;
      flex-direction: column;
      background-image: linear-gradient(270deg, #3d83ff 0%, #3a48db 100%);
      padding-top: 20px;
      box-sizing: border-box;
      .thumbs {
        flex: 1;
        margin: 0;
        padding: 0 20px 0 0;
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }

        .thumbs-item {
          position: relative;
          font-size: 18px;
          color: #ffffff;
          line-height: 24px;
          margin-bottom: 20px;
          margin-left: 20px;
          height: 72px;
          display: flex;
          cursor: pointer;
          &:last-of-type {
            margin-bottom: 12px;
          }
          &.active {
            .img {
              border: 1px solid #09dda8;
            }
            .video-desc {
              span {
                color: #09dda8 !important;
              }
              .date {
                .playing {
                  display: flex;
                }
              }
            }
          }
          .img {
            height: 72px;
            width: 128px;
            background-color: #ffffff;
            border: 1px solid rgba(255, 255, 255, 0);
            box-sizing: border-box;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .video-desc {
            margin-left: 10px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .date {
              height: 20px;
              opacity: 0.5;
              font-size: 12px;
              color: #ffffff;
              line-height: 18px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .playing {
                display: none;
                width: 20px;
                height: 20px;
                justify-content: space-between;
                align-items: flex-end;
                padding: 2px;
                box-sizing: border-box;
                .playing__bar {
                  display: inline-block;
                  background: #09dda8;
                  width: 2px;
                  height: 100%;
                  -webkit-animation: up-and-down 1.3s ease infinite alternate;
                  animation: up-and-down 1.3s ease infinite alternate;
                }

                .playing__bar1 {
                  height: 60%;
                }

                .playing__bar2 {
                  height: 30%;
                  -webkit-animation-delay: -2.4s;
                  animation-delay: -2.4s;
                }

                .playing__bar3 {
                  height: 75%;
                  -webkit-animation-delay: -3.7s;
                  animation-delay: -3.7s;
                }
                .playing__bar4 {
                  height: 45%;
                  -webkit-animation-delay: -1.7s;
                  animation-delay: -1.7s;
                }
                .playing__bar5 {
                  height: 100%;
                  -webkit-animation-delay: -2.7s;
                  animation-delay: -2.7s;
                }

                @-webkit-keyframes up-and-down {
                  10% {
                    height: 30%;
                  }
                  30% {
                    height: 100%;
                  }
                  60% {
                    height: 50%;
                  }
                  80% {
                    height: 75%;
                  }
                  100% {
                    height: 20%;
                  }
                }

                @keyframes up-and-down {
                  10% {
                    height: 30%;
                  }
                  30% {
                    height: 100%;
                  }
                  60% {
                    height: 50%;
                  }
                  80% {
                    height: 75%;
                  }
                  100% {
                    height: 20%;
                  }
                }
              }
            }
            span {
              font-size: 16px;
              color: #ffffff;
              line-height: 20px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .set {
        padding-top: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        justify-content: flex-start;
      }
    }
    #video {
      flex: 1;
      /deep/ img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .set {
    display: flex;
    justify-content: center;
    align-items: center;
    .prev {
      cursor: pointer;
      display: inline-block;
      width: 30px;
      height: 30px;
      background: #3d72f5;
      text-align: center;
      line-height: 30px;
      color: #ffffff;
      font-size: 12px;
      outline: none;
      transition: background 0.1s;
      &:hover {
        background: #09dda8;
      }
      &::before {
        content: "\e7fa";
        display: inline-block;
        font-family: "iconfont";
      }
    }
    .next {
      cursor: pointer;
      display: inline-block;
      width: 30px;
      height: 30px;
      background: #3d72f5;
      text-align: center;
      line-height: 30px;
      color: #ffffff;
      font-size: 12px;
      outline: none;
      margin-left: 10px;
      transition: background 0.1s;
      &:hover {
        background: #09dda8;
      }

      &::before {
        content: "\e7fb";
        display: inline-block;
        font-family: "iconfont";
      }
    }
  }
}
</style>
